import { render, staticRenderFns } from "./GoalMain.vue?vue&type=template&id=7409186e&"
import script from "./GoalMain.vue?vue&type=script&lang=ts&"
export * from "./GoalMain.vue?vue&type=script&lang=ts&"
import style0 from "./GoalMain.vue?vue&type=style&index=0&id=7409186e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports